import { useState } from "react";
import { post } from "../networking/RequestService";
import { apiErrorText } from "app/popleads/networking/apiErrorText";

function useDeleteProfileInfo() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const deleteProfileInfo = async (params = {}) => {
        setLoading(true);
        setError(null);

        const { profileId, param, paramValue } = params;

        if (!profileId || !param || !paramValue) {
            const errorMessage = "Missing required parameters";
            setError(errorMessage);
            setLoading(false);
            return { error: errorMessage };
        }

        const payload = {
            fn: "deleteProfileInfo",
            profileId,
            param,
            paramValue,
        };

        try {
            const response = await post(payload);
            return { data: response.data };
        } catch (error) {
            const errorMessage = apiErrorText(error);
            setError(errorMessage);
            return { error: errorMessage };
        } finally {
            setLoading(false);
        }
    };

    return { deleteProfileInfo, loading, error };
}

export default useDeleteProfileInfo;
